module.exports = __webpack_public_path__ + "img/logo_down.7f737805.png";